module.exports = ".menubutton{font-size:20px}\n"